import { render, staticRenderFns } from "./SelectedDeals.vue?vue&type=template&id=17980886&scoped=true&"
import script from "./SelectedDeals.vue?vue&type=script&lang=js&"
export * from "./SelectedDeals.vue?vue&type=script&lang=js&"
import style0 from "./SelectedDeals.vue?vue&type=style&index=0&id=17980886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17980886",
  null
  
)

export default component.exports